<template>
  <section class="jsk-block">
      <div class="container">
          <div class="row">
              <div class="col-12 col-lg-4 col-md-4 col-sm-4 text-center">
                  <a href="https://jsleague.ro" target="_blank">
                    <img src="./../assets/images/partners/jsleague.png" class="w-25">
                  </a>  
              </div>
              <div class="col-12 col-lg-4 col-md-4 col-sm-4 text-center">
                  <a href="https://scoaladevalori.ro/" target="_blank">
                    <img src="./../assets/images/partners/sdv.png" class="w-50">
                  </a>  
              </div>
              <div class="col-12 col-lg-4 col-md-4 col-sm-4 text-center">
                  <a href="https://bucharest.techhub.com/" target="_blank">
                    <img src="./../assets/images/partners/techhub.png" class="w-50">
                  </a>  
              </div>
          </div>
      </div>
    </section>
</template>

<script>

export default {
  name: "partnersLogos"
};
</script>